import { Button, Flex, Form, Input, Modal, Typography } from 'antd'
import { Dispatch, SetStateAction } from 'react'
import { submitCreateAdjustmentDeposit } from 'src/pages/billing/deposits/edit/model'

type Props = {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  transactionId: string
}
type FormValue = {
  actualClientAmount: number
}

export const AdjustmentDepositModal = ({
  transactionId,
  open,
  setOpen,
}: Props) => {
  const { Item } = Form
  const { Text } = Typography

  const handleCancel = () => {
    setOpen(false)
  }

  const handleSubmit = (form: FormValue) => {
    submitCreateAdjustmentDeposit({
      sourceTransactionRequestId: transactionId,
      actualClientAmount: form.actualClientAmount,
    })
    setOpen(false)
  }

  return (
    <Modal
      title={<div style={{ fontSize: 20 }}>Create Adjustment Deposit</div>}
      centered
      wrapClassName="ant_modal"
      width={400}
      maskClosable={false}
      open={open}
      destroyOnHidden
      onCancel={handleCancel}
      footer={null}
    >
      <Form layout="vertical" onFinish={handleSubmit}>
        <Item
          label={<Text style={{ fontSize: 16 }}>Actual Client Amount</Text>}
          name="actualClientAmount"
          rules={[
            {
              required: true,
              message: 'Required field',
            },
            {
              pattern: /^\d+(?:[.,]\d+)?$/,
              message:
                'Amount must be a positive number using dot or comma as decimal separator',
            },
          ]}
        >
          <Input />
        </Item>
        <Flex gap={8} justify="flex-end">
          <Button onClick={handleCancel}>Cancel</Button>
          <Button type="primary" htmlType="submit">
            Create
          </Button>
        </Flex>
      </Form>
    </Modal>
  )
}
